define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/xml"
], function(declare,lang,Controller,xml) {

	return declare(Controller, {
		getFormData: function() {
			// summary: make sure that at least one Style is selected and require edit rights on the styles
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateStyle);
			return fd;
		},

		_canAggregateStyle: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: only allow selection of nodes with Write access
			return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
		}
	});
});
